/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistake_7Inputs */

const en_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiating over email instead of a call`)
};

const de_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per E-Mail verhandeln statt telefonisch`)
};

const fr_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Négocier par e-mail au lieu d'un appel`)
};

const es_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negociar por correo electrónico en vez de por llamada`)
};

const it_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negoziare via email invece che al telefono`)
};

const nl_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderhandelen via e-mail in plaats van bellen`)
};

const pl_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negocjowanie przez e-mail zamiast telefonicznie`)
};

const fi_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuvottelu sähköpostilla puhelun sijaan`)
};

const da_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At forhandle over e-mail i stedet for et opkald`)
};

const sv_salary_negotiate_mistake_7 = /** @type {(inputs: Salary_Negotiate_Mistake_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att förhandla via e-post istället för ett samtal`)
};

/**
* | output |
* | --- |
* | "Negotiating over email instead of a call" |
*
* @param {Salary_Negotiate_Mistake_7Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistake_7 = /** @type {((inputs?: Salary_Negotiate_Mistake_7Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistake_7Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistake_7(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistake_7(inputs)
	if (locale === "es") return es_salary_negotiate_mistake_7(inputs)
	if (locale === "it") return it_salary_negotiate_mistake_7(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistake_7(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistake_7(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistake_7(inputs)
	if (locale === "da") return da_salary_negotiate_mistake_7(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistake_7(inputs)
	return en_salary_negotiate_mistake_7(inputs)
});